import { BaseQuery } from 'types'

const defaultPagination: BaseQuery = Object.freeze({
  limit: 25,
  offset: 0,
})

export { defaultPagination }
